<template>
  <div class="*:text-xs flex flex-wrap flex-row gap-2 *:text-nowrap">
    <vetster-outline-badge
      v-if="isVcprEnabled && isVcprSearch"
      v-tippy="tippyOptions"
      :icon="['fas', 'check']"
      :content="$t('search.can-prescribe-medications')"
    >
      <template #label>
        {{ $t('search.prescriptions-available') }}
      </template>
    </vetster-outline-badge>
    <vetster-outline-badge
      v-tippy="tippyOptions"
      :icon="['fas', 'check']"
      :content="$t('search.verified-license', { region: licenseRegion })"
    >
      <template #label>
        {{ $t('search.license-verified') }}
      </template>
    </vetster-outline-badge>
    <vetster-outline-badge
      v-if="!isInState && isVcprSearch"
      v-tippy="tippyOptions"
      color="neutral"
      :icon="['fal', 'location-dot']"
      :content="$t('search.while-this-vet-is-out-of-state')"
    >
      <template #label>
        {{ $t('search.out-of-state') }}
      </template>
    </vetster-outline-badge>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faLocationDot } from '@fortawesome/pro-light-svg-icons';

import VetsterOutlineBadge from '@/brand-components/VetsterOutlineBadge';

library.add(faLocationDot);

export default {
  name: 'VetsterPartnerBadges',

  components: { VetsterOutlineBadge },

  props: {
    isInState: {
      type: Boolean,
      default: false,
    },
    isVcprEnabled: {
      type: Boolean,
      default: false,
    },
    isVcprSearch: {
      type: Boolean,
      default: false,
    },
    partner: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      tippyOptions: {
        popperOptions: {
          strategy: 'fixed',
        },
      },
    };
  },

  computed: {
    licenseRegion() {
      return this.partner.license_guidelines?.license_jurisdiction?.code;
    },
  },
};
</script>
